import { useState, useEffect } from 'react';
import { checkIsBrowser } from './windowObj.js';
import { MOBILE_SCREEN_WIDTH, TABLET_SCREEN_WIDTH } from '../../constants/common/screen.js';
import { checkIsDefined } from '../../features/Common/modules/DataTypes/utils/nanNullUndef.js';

var SERVER_SIDE_DIMENSION = -1;
var useScreenSize = function () {
    var getWidth = function () {
        return checkIsBrowser() ? window.innerWidth : SERVER_SIDE_DIMENSION;
    };
    var getHeight = function () {
        return checkIsBrowser() ? window.innerHeight : SERVER_SIDE_DIMENSION;
    };
    var _a = useState(getWidth()), width = _a[0], setWidth = _a[1];
    var _b = useState(getHeight()), height = _b[0], setHeight = _b[1];
    var updateDimensions = function () {
        setWidth(getWidth());
        setHeight(getHeight());
    };
    useEffect(function () {
        updateDimensions();
        window.addEventListener("resize", updateDimensions);
        return function () {
            window.removeEventListener("resize", updateDimensions);
        };
    }, []);
    return { width: width, height: height };
};
var useIsDesktop = function (options) {
    var width = useScreenSize().width;
    var serverSideValue = options === null || options === void 0 ? void 0 : options.serverSideValue;
    if (checkIsDefined(serverSideValue) && width === SERVER_SIDE_DIMENSION) {
        return serverSideValue;
    }
    return width > MOBILE_SCREEN_WIDTH;
};
var useIsTablet = function (options) {
    var width = useScreenSize().width;
    var serverSideValue = options === null || options === void 0 ? void 0 : options.serverSideValue;
    if (checkIsDefined(serverSideValue) && width === SERVER_SIDE_DIMENSION) {
        return serverSideValue;
    }
    return width > TABLET_SCREEN_WIDTH;
};

export { useIsDesktop, useIsTablet, useScreenSize };
//# sourceMappingURL=screen.js.map
